var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container",on:{"click":_vm.changeChart}},[_c('div',[_c('img',{attrs:{"src":require('@/assets/' + _vm.chartIcon),"alt":""}})])])}
var staticRenderFns = []

export { render, staticRenderFns }